export enum ScanOption {
  'No Scan' = 1,
  'SP Scan' = 2,
  'HQ Scan' = 3,
}

export namespace ScanOption {
  export function values() {
    return Object.keys(ScanOption).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
